import React from "react";
import "./style.scss";
import { useTranslation } from "locales";
import BaseIcon from "components/BaseIcon";

export default function BlockStudents() {
  const { t } = useTranslation();

  const cards = [
    {
      title: t("Interview-Ready"),
      description: t("Personalised, practical coaching for every interview stage."),
      icon: t("user-check"),
    },
    {
      title: t("Real-Market Practice"),
      description: t("Real market examples and case simulations."),
      icon: t("trending-up"),
    },
    {
      title: t("Industry-Approved"),
      description: t("Confidence that your preparation meets industry standards."),
      icon: t("award"),
    },
  ];

  return (
    <div className="block-students">
      <h1 className="block-students__title h1 mb-4 text-center mx-auto mt-10">{t("Clarity. Confidence. Offers.")}</h1>
      <div className="block-students__description subtitle-1 text-neutral-darken-1 mb-10 text-center mx-auto">
        {t(
          "Our coaching helps you perform at your best — from the first CV draft to the final interview. Learn directly from finance professionals who’ve been through the process and know what it takes to get hired at the world’s top firms."
        )}
      </div>
      <div className="block-students__card-wrapper d-flex __wrap __justify-center">
        {cards.map((card, index) => (
          <div key={index} className="block-students__card box-shadow d-flex __column __align-center pa-6 text-center">
            <div className="block-students__card-icon d-center mb-3">
              <BaseIcon size={32}>{card.icon}</BaseIcon>
            </div>
            <div className="caption-1 fw-bold mb-1">{card.title}</div>
            <div className="text-neutral-darken-1">{card.description}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
